/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export { BROWSER_SANITIZATION_PROVIDERS as ɵBROWSER_SANITIZATION_PROVIDERS, INTERNAL_BROWSER_PLATFORM_PROVIDERS as ɵINTERNAL_BROWSER_PLATFORM_PROVIDERS, initDomAdapter as ɵinitDomAdapter } from "./browser";
export { BrowserDomAdapter as ɵBrowserDomAdapter } from "./browser/browser_adapter";
export { BrowserPlatformLocation as ɵBrowserPlatformLocation } from "./browser/location/browser_platform_location";
export { TRANSITION_ID as ɵTRANSITION_ID } from "./browser/server-transition";
export { BrowserGetTestability as ɵBrowserGetTestability } from "./browser/testability";
export { escapeHtml as ɵescapeHtml } from "./browser/transfer_state";
export { ELEMENT_PROBE_PROVIDERS as ɵELEMENT_PROBE_PROVIDERS } from "./dom/debug/ng_probe";
export { DomAdapter as ɵDomAdapter, getDOM as ɵgetDOM, setRootDomAdapter as ɵsetRootDomAdapter } from "./dom/dom_adapter";
export { DomRendererFactory2 as ɵDomRendererFactory2, NAMESPACE_URIS as ɵNAMESPACE_URIS, flattenStyles as ɵflattenStyles, shimContentAttribute as ɵshimContentAttribute, shimHostAttribute as ɵshimHostAttribute } from "./dom/dom_renderer";
export { DomEventsPlugin as ɵDomEventsPlugin } from "./dom/events/dom_events";
export { HammerGesturesPlugin as ɵHammerGesturesPlugin } from "./dom/events/hammer_gestures";
export { KeyEventsPlugin as ɵKeyEventsPlugin } from "./dom/events/key_events";
export { DomSharedStylesHost as ɵDomSharedStylesHost, SharedStylesHost as ɵSharedStylesHost } from "./dom/shared_styles_host";
//# sourceMappingURL=private_export.js.map


// WEBPACK FOOTER //
// ../../../packages/platform-browser/esm5/src/private_export.js